import { makeStyles } from '@material-ui/core/styles';
import LeftIcon from './arrow_left_icon.svg';
import RightIcon from './arrow_right_icon.svg';

const textStyle = {
  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.14',
  letterSpacing: 'normal',
};

export const useStyles = makeStyles((theme) => ({
  list: {
    width: '300px',
    height: '40px',
    borderRadius: '5px',
    border: '1px solid #B5B5B5',
    paddingLeft: '10px',
  },
  input: {
    width: '100%',
    '& > div': {
      marginRight: '0 !important',
    },
  },
  wrapper: {
    width: '100%',
    '& > div': {
      width: '100% !important',
    },
  },
  staticText: {
    padding: '0 24px 20px 26px',
    width: '100%',
    borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      '& svg': {
        fill: '#666',
        color: '#666',
      },
      '& $staticTextArrow svg': {
        fill: '#666',
        color: '#666',
      },
    },
  },
  staticTextMain: {
    ...textStyle,
    flex: '0 0 100%',
    display: 'flex',
    alignItems: 'center',
    color: '#212121',
    '& svg': {
      width: '20px',
      height: '20px',
      marginRight: '8px',
      fill: '#cccccc',
      color: '#cccccc',
    },
  },
  staticTextArrow: {
    flex: '0 0 7.2px',
    '& svg': {
      width: '7.2px',
      height: '12px',
      fill: '#cccccc',
      color: '#cccccc',
    },
  },
  dateTimeContainer: {
    position: 'absolute',
    height: 'calc(100vh - 104px)',
    width: '100%',
    top: '0px',
    background: 'var(--white)',
    zIndex: '10',
    display: 'grid',
    overflow: 'auto',
    gridTemplateRows: 'auto 1fr auto',
    '& > div:first-child': {
      padding: '25px 30px 18px',
      height: '77px',
      borderBottomColor: '#f5f5f5',
    },
    '@media (max-width: 600px)': {
      height: 'calc(100vh - 48px)',
    },
  },
  title: {
    position: 'relative',
    fontSize: '30px',
    fontWeight: 500,
    textAlign: 'left',
    margin: 0,
    padding: '25px 30px 18px;',
    color: 'var(--gray-13-color)',
    borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)',
  },
  backButton: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    width: '17px',
    height: '17px',
    cursor: 'pointer',
    fill: '#999',
    '&:hover': {
      fill: ' #3f51b5',
    },
    '@media (max-width: 600px)': {
      top: '15px',
      right: '35px',
    },
  },
  radioGroup: {
    overflow: 'hidden !important',
    overflowAnchor: 'none',
    touchAction: 'auto',
    flexDirection: 'row',
    display: 'block',
  },
  icon: {
    boxSizing: 'border-box',
    height: '16px',
    width: '16px',
    borderRadius: '100px',
    backgroundColor: '#FFF',
    border: '2px solid #b8bdd0',
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      borderRadius: '50%',
      height: 0,
      width: 0,
      left: '50%',
      top: '50%',
      transform: 'translate(-50%,-50%)',
      transition: 'all 150ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
    },
  },
  checkedIcon: {
    '&:after': {
      height: 6,
      width: 6,
      border: '5px solid #202020',
    },
  },
  optionBlock: {
    padding: '12px 31px 15px',
    width: 'auto',
    borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)',
    '@media (max-width: 600px)': {
      paddingLeft: '15px',
    },
  },
  optionStyle: {
    ...textStyle,
  },
  button: {
    height: '50px !important',
    width: 'auto',
    margin: '30px 26px',
    borderRadius: '8px',
    border: 'solid 2px var(--deepBlue)',
    boxShadow: '0 3px 15px 0 rgba(52, 73, 149, 0.1)',
    backgroundColor: 'var(--white)',
    color: 'var(--deepBlue)',
    '&:hover': {
      color: 'var(--white) !important',
      backgroundColor: 'var(--deepBlue)',
    },
    boxSizing: 'border-box',
    '@media (max-width: 600px)': {
      width: 'calc(100vw - 55px)',
    },
  },
  timeBlock: {
    position: 'relative',
    marginTop: '18px',
    '& input': {
      fontSize: '20px',
      padding: '16px 15px 16px 20px',
      width: '50px',
    },
  },
  popper: {
    zIndex: '555',
    width: 'auto',
    fontSize: '22px',
    margin: '0',
    marginTop: '10px',
    border: 'none',
    '& .react-datepicker__day--outside-month': {
      color: '#808080 !important',
      '&:hover': {
        color: 'var(--ctgBlue) !important',
      },
    },
    '& .react-datepicker__header': {
      backgroundColor: 'transparent',
      border: 'none',
    },
    '& .react-datepicker__month': {
      margin: '0',
    },
    '& .react-datepicker__month-container': {
      float: 'none',
      width: 'auto',
      margin: '0',
    },
    '& .react-datepicker__day': {
      width: '48px',
      height: '48px',
      margin: '0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      color: '#202020',
      '&:hover': {
        border: 'solid 2px var(--light-blue-grey-30)',
        borderRadius: '5px',
        backgroundColor: 'transparent',
        color: 'var(--ctgBlue)',
      },
      '&:focus': {
        outline: 'none',
      },
    },
    '& .react-datepicker__day--today': {
      fontWeight: '400 !important',
    },
    '& .react-datepicker__day--disabled': {
      color: 'var(--light-grey-blue) !important',
      '&:hover': {
        border: 'none !important',
      },
    },
    '& .react-datepicker__week': {
      display: 'grid',
      gridTemplateColumns: '50px 50px 50px 50px 50px 50px 50px',
      margin: '0',
      marginBottom: '2px',
    },
    '& .react-datepicker__day-names': {
      display: 'grid',
      margin: '0',
      gridTemplateColumns: '50px 50px 50px 50px 50px 50px 50px',
    },
    '& .react-datepicker__day-name': {
      fontSize: '16px',
      display: 'grid',
      margin: '0',
      marginBottom: '5px',
      gridTemplateColumns: '50px 50px 50px 50px 50px 50px 50px',
    },
    '& .react-datepicker__current-month': {
      width: '154px',
      fontSize: '16px',
      margin: '0 auto 8px',
      fontWeight: '400',
    },
    '& .react-datepicker__navigation:focus': {
      outline: 'none',
    },
    '& .react-datepicker__navigation--previous': {
      right: 'calc(100% - 80px)',
      left: 'auto',
      backgroundImage: `url(${LeftIcon})`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      fill: '#d9d9d9',
      border: 'none',
      width: '8px',
      height: '14px',
    },
    '& .react-datepicker__navigation--next': {
      left: 'calc(100% - 80px)',
      right: 'auto',
      backgroundImage: `url(${RightIcon})`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      fill: '#d9d9d9',
      border: 'none',
      width: '8px',
      height: '14px',
    },
    '& .react-datepicker__day--selected': {
      backgroundColor: 'var(--light-blue-grey-20) !important',
      color: 'var(--ctgBlue)',
      border: 'none',
    },
  },
  keyBoardSelected: {
    '& .react-datepicker__day--keyboard-selected': {
      backgroundColor: 'var(--light-blue-grey-20) !important',
      color: 'var(--ctgBlue)',
      border: 'none',
    },
  },
}));
